//Custo css import
import './style.css'

import Form from 'react-bootstrap/Form';
import { EmptyArray } from '../../../domain/empty/model';

//React import
import { useCallback, useEffect, useMemo, useState } from 'react';

import Table from '../../molecules/tablas/view'
import NewService from '../NewService/view';
import ButtonAction from '../../atoms/buttonAction/view';
import ConfirmPopUp from '../../atoms/confirmPopUp/view';
import FacetedFilter from '../../molecules/FacetedFilter/view';
import { Trash2, ToggleLeft, Coins } from 'lucide-react';

import { getServices, deleteService } from '../../../usecases/service-usecase';
import { listener, dispatchCustomEvent } from '../../../utils/dispatch';
import { mapServicesListForTable } from '../../../infrastructure/mappers/service-mapper';
import { Switch } from '@mui/material';
import EditService from '../EditService/view';


import { BsFillCartCheckFill } from 'react-icons/bs';
import { FaClone } from 'react-icons/fa';

function IsEnable(e) {
    function is_enable(enable) {
        if (enable == null) {
            return true
        }
        return enable
    }

    function changeEnable() {
        //isEnable(data.sku, check)
    }

    return <Switch defaultChecked={is_enable(e.data.enable)} onChange={(event) => changeEnable(e.data, event.target.checked)}></Switch>
}

function DeleteServiceBtn({ data }) {
    return (
        <ButtonAction
            id={`delete-service-${data?.id}`}
            btnKey="delete-service"
            onClick={() => dispatchCustomEvent('btn-notification-confirm-delete-service', data)}
            title={<Trash2 size={14} />}
            style={{ width: '100%' }}
        />
    );
}

function ServicesTable({ ref, tableHeight, profile, type = "stock" }) {

    const [activeFilters, setActiveFilters] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState({
        isActive: null,
        hasTax: null,
    });

    const [servicesData, setServicesData] = useState({
        data: undefined,
        page: 1,
        page_size: 10,
        total: 0,
    });
    const [isLoading, setIsLoading] = useState(true);
    const [allServices, setAllServices] = useState([]);
    const [query, setQuery] = useState("");

    const filtersConfig = useMemo(() => [
        {
            key: 'isActive',
            label: 'Estado',
            icon: <ToggleLeft size={14} />,
            type: 'select',
            options: [
                { value: 'true', label: 'Activos' },
                { value: 'false', label: 'Inactivos' },
            ]
        },
        {
            key: 'hasTax',
            label: 'Impuesto',
            icon: <Coins size={14} />,
            type: 'select',
            options: [
                { value: 'true', label: 'Gravados' },
                { value: 'false', label: 'Exentos' },
            ]
        },
    ], []);

    // Aplica filtros activos al estado de appliedFilters
    useEffect(() => {
        const filters = { isActive: null, hasTax: null };
        activeFilters.forEach(f => {
            if (f.key === 'isActive') filters.isActive = f.value === 'true';
            if (f.key === 'hasTax') filters.hasTax = f.value === 'true';
        });
        setAppliedFilters(filters);
    }, [activeFilters]);

    const setup = useMemo(() => {
        if (type === "sell") {
            return {
                headers: [
                    "sku",
                    "Nombre",
                    "Descripción",
                    "Valor",
                    "Unidad"
                ],
                exclude: [
                    "created_at",
                    "users_id",
                    "id",
                    "updated_at",
                    "taxes_id",
                    "tax",
                    "impuesto",
                    "tax_name",
                    "tax_value",
                    "is_active"
                ],
                actions: {
                    add: true,
                    clone: true
                }
            };
        }
        return {
            headers: [
                "sku",
                "Nombre",
                "Descripción",
                "Valor",
                "Unidad",
                "Activo"
            ],
            exclude: [
                "created_at",
                "users_id",
                "id",
                "updated_at",
                "taxes_id",
                "tax",
                "impuesto",
                "tax_name",
                "tax_value"
            ],
            actions: {
                edit: true,
                delete: true
            }
        };
    }, [type]);

    /**
     * Aplica filtros del lado del cliente sobre la lista completa de servicios.
     * El backend de servicios no soporta parámetros de filtro adicionales.
     */
    const applyClientFilters = useCallback((list, filters, searchQuery) => {
        let result = [...list];

        if (searchQuery) {
            const q = searchQuery.toLowerCase();
            result = result.filter(s =>
                s.name?.toLowerCase().includes(q) ||
                s.sku?.toLowerCase().includes(q) ||
                s.description?.toLowerCase().includes(q)
            );
        }

        if (filters.isActive !== null) {
            result = result.filter(s => Boolean(s.is_active) === filters.isActive);
        }

        if (filters.hasTax !== null) {
            result = result.filter(s => Boolean(s.taxes_id) === filters.hasTax);
        }

        return result;
    }, []);

    function fetchServices(page = servicesData.page, limit = servicesData.page_size, q = query) {
        setIsLoading(true);
        getServices(page, limit, q).then((res) => {
            if (res.data.total === 0) {
                setServicesData({
                    data: EmptyArray,
                    page: page,
                    page_size: limit,
                    total: 0
                })
                setAllServices([]);
            } else {
                const mapped = mapServicesListForTable(res.data.data);
                setAllServices(mapped);
                setServicesData({
                    ...res.data,
                    data: mapped
                })
            }
        }).catch(() => {
            setServicesData({
                data: EmptyArray,
                page: page,
                page_size: limit,
                total: 0
            })
            setAllServices([]);
        }).finally(() => {
            setIsLoading(false);
        })
    }

    // Re-filtra en cliente cuando cambian los filtros aplicados
    useEffect(() => {
        if (allServices.length === 0) return;
        const filtered = applyClientFilters(allServices, appliedFilters, query);
        setServicesData(prev => ({
            ...prev,
            data: filtered.length > 0 ? filtered : EmptyArray,
            total: filtered.length,
        }));
    }, [appliedFilters]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!servicesData.data || servicesData.data.length === 0) fetchServices()
        // Wrapeamos en función anónima para evitar que el CustomEvent se pase
        // como primer argumento a fetchServices (lo que corrompería el param `page`)
        const reloadServices = () => fetchServices()
        listener('service-edited', reloadServices)
        listener('service-added', reloadServices)
        listener('reload-services', reloadServices)
    }, []);

    function handleSearch(val) {
        setQuery(val)
        if (activeFilters.length > 0 && allServices.length > 0) {
            // Si hay filtros activos, buscamos dentro del set filtrado en cliente
            const filtered = applyClientFilters(allServices, appliedFilters, val);
            setServicesData(prev => ({
                ...prev,
                data: filtered.length > 0 ? filtered : EmptyArray,
                total: filtered.length,
            }));
        } else {
            fetchServices(1, servicesData.page_size, val)
        }
    }

    const handleDeleteService = (service) => {
        if (servicesData.total <= 1) {
            dispatchCustomEvent('popup', {
                message: 'No puedes eliminar el último servicio disponible.',
                type: 'error'
            });
            return;
        }
        deleteService(service.id)
            .then(() => {
                dispatchCustomEvent('popup', {
                    message: 'Servicio eliminado correctamente',
                    type: 'success',
                });
                fetchServices(1, servicesData.page_size, query);
            })
            .catch((err) => {
                dispatchCustomEvent('popup', {
                    message: err.response?.data?.message || 'Error al eliminar el servicio',
                    type: 'error',
                });
            });
    };

    return (
        <>
            <ConfirmPopUp
                eventKey="delete-service"
                msg="¿Estás seguro de eliminar este servicio? Esta acción no se puede deshacer."
                onAcept={handleDeleteService}
            />

            {/* Barra de filtros — misma posición que en ProductsTable */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                <FacetedFilter
                    filters={filtersConfig}
                    activeFilters={activeFilters}
                    onChange={setActiveFilters}
                    onClear={() => setActiveFilters([])}
                />
            </div>

            <Table
                id="services-table"
                isLoading={isLoading}
                emptyMessage="Aun no tienes servicios"
                emptyChild={<NewService id="services-table" profile={profile}></NewService>}
                maxHeight={tableHeight ? tableHeight : "35vh"}
                headersList={setup ? setup.headers : []}
                paginatedData={servicesData}
                getFunction={fetchServices}
                allowExport={true}
                exportFileName="servicios"
                allowPageSizeControl={true}
                excludeList={setup ? setup.exclude : []}
                allowSearch={true}
                onSearch={handleSearch}
                formats={{
                    value: { type: 'money' },
                    name: { type: 'tooltip' },
                    description: { type: 'icon_tooltip' },
                    unit: { type: 'chip' },
                    is_active: {
                        type: "custom",
                        children: <IsEnable />
                    },
                }}
            >
                {type === 'stock' ? [
                    <EditService key="edit" />,
                    <DeleteServiceBtn key="delete" />
                ] : [
                    <ButtonAction
                        key="add"
                        title={<BsFillCartCheckFill />}
                        onClick={(service) => dispatchCustomEvent("btn-add-product", {
                            ...service,
                            is_service: true,
                            type: 'service',
                            tax_sell_value: service.tax_value ?? (service.taxes_id ? 19 : 0)
                        })}
                    />,
                    <ButtonAction
                        key="clone"
                        title={<FaClone />}
                        onClick={(service) => dispatchCustomEvent("btn-clone-product", {
                            ...service,
                            is_service: true,
                            type: 'service',
                            tax_sell_value: service.tax_value ?? (service.taxes_id ? 19 : 0)
                        })}
                    />
                ]}
            </Table>
        </>
    )
}

export default ServicesTable;
